import get from "lodash/get";
import { array, object, string } from "prop-types";
import React from "react";
import { connect } from "react-redux";

import { getCollectionName, getSlug } from "../../utils/utils";

import CollectionTitleWithArrow from "../../atoms/CollectionTitleWithArrow";
import Row from "./Row";

import "./multipurposeComponent.m.css";

const MultipurposeComponent = ({ collection, sections, publisherAttributes, domainSlug }) => {
  const navigateTo = get(collection, ["associated-metadata", "navigate_to"], "");
  const navigateToTitle = get(collection, ["associated-metadata", "navigate_to_title"], "");

  const columnColor0 = get(collection, ["associated-metadata", "first_column_color"], "");
  const columnColor1 = get(collection, ["associated-metadata", "second_column_color"], "");
  const columnColor2 = get(collection, ["associated-metadata", "third_column_color"], "");
  const columnColor3 = get(collection, ["associated-metadata", "fourth_column_color"], "");

  const collectionSlug = navigateTo ? `/${navigateTo}` : getSlug(collection, sections, domainSlug);
  const collectionName = getCollectionName(collection, navigateToTitle);

  const showCollectionName = get(collection, ["associated-metadata", "show_collection_name_website"], null);
  const showSubHeading = get(collection, ["associated-metadata", "show_sub_heading_in_website"], true);

  const subCollections = collection.items;
  const wrapperClass = subCollections.length === 2 ? "two-column" : "one-column";

  return (
    <div styleName="base" className="multipurpose-components" data-testid="12-stories">
      {showCollectionName && (
        <CollectionTitleWithArrow
          collectionSlug={collectionSlug}
          collectionName={collectionName}
          headlineClassName="collection-name-arrow"
          updatedFont={true}
        />
      )}
      <div styleName={`wrapper ${wrapperClass}`}>
        {subCollections &&
          subCollections.map((collection, index) => (
            <Row
              key={index}
              colNumber={index}
              collection={collection}
              showSubHeading={showSubHeading}
              columnColor0={columnColor0}
              columnColor1={columnColor1}
              columnColor2={columnColor2}
              columnColor3={columnColor3}
            />
          ))}
      </div>
    </div>
  );
};

MultipurposeComponent.propTypes = {
  collection: object,
  sections: array,
  publisherAttributes: object,
  domainSlug: string,
};

const mapStateToProps = (state) => ({
  sections: get(state, ["qt", "config", "sections"], []),
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
  domainSlug: get(state, ["qt", "config", "domainSlug"], ""),
});

export default connect(mapStateToProps, null)(MultipurposeComponent);
